module.exports = __webpack_public_path__ + "static/media/heerdeonline.9282a28b.png";